export const whyVoxmasterStats = [
  { value: "60M+", label: "Minutes routed annually" },
  { value: "99.99%", label: "Platform uptime SLA" },
  { value: "61.4%", label: "Global average ASR" },
  { value: "<45ms", label: "Median PDD, US routes" },
  { value: "48h", label: "Typical time-to-live" },
  { value: "700+", label: "Direct interconnects" },
];

export const differentiators = [
  {
    icon: "ri-rocket-2-line",
    title: "Stability you can bank on",
    desc: "Four redundant PoPs across three continents. N+1 SBC at every site. Multi-transit peering with a minimum of three carriers per PoP. If a route degrades, traffic shifts automatically before you hear a single dropped call.",
    color: "primary",
  },
  {
    icon: "ri-award-line",
    title: "Route quality measured. Not claimed.",
    desc: "ASR, PDD, ACD, MOS — every destination is probed every 60 seconds from every PoP. You see the same live dashboards our NOC uses. No cherry-picked samples, no marketing rounding.",
    color: "accent",
  },
  {
    icon: "ri-speed-up-line",
    title: "Connection speed that closes deals",
    desc: "From signed NDA to first test call in as little as 48 hours. Pre-configured SBC templates for FreeSWITCH, Asterisk, Kamailio, and Cisco. IP authentication, codec profile, and routing table — done before your coffee gets cold.",
    color: "secondary",
  },
  {
    icon: "ri-eye-line",
    title: "Transparency. No games.",
    desc: "Per-minute, per-destination rates with no hidden fees. Rate decks updated weekly and versioned. Every CDR is searchable, exportable, and reconciled against your invoice. If a rate changes, you know before the billing cycle closes.",
    color: "primary",
  },
  {
    icon: "ri-tools-line",
    title: "Commercial flexibility",
    desc: "Post-paid and pre-paid billing. Flat-rate and tiered pricing. Custom LCR quotes matched to your traffic profile. No minimum commitment — start small, scale when you are ready.",
    color: "accent",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "Support that actually supports",
    desc: "Three shifts, follow-the-sun NOC — North America, Europe, Asia Pacific. Reach us on Telegram, WhatsApp, email, or ticket. You are talking to an engineer who sees your traffic, not a triage script.",
    color: "secondary",
  },
];

export const comparisonRows = [
  { feature: "Route quality probes", voxmaster: "Every 60s, all dest.", typical: "5–15 min intervals", winner: "voxmaster" },
  { feature: "Auto-failover speed", voxmaster: "Within 1 attempt", typical: "5–30 seconds", winner: "voxmaster" },
  { feature: "NOC response time", voxmaster: "< 5 min (human)", typical: "< 30 min", winner: "voxmaster" },
  { feature: "Rate deck updates", voxmaster: "Weekly, versioned", typical: "Biweekly or on request", winner: "voxmaster" },
  { feature: "SBC redundancy", voxmaster: "N+1 per PoP", typical: "Active/passive pair", winner: "voxmaster" },
  { feature: "CDR granularity", voxmaster: "Per-call, real-time", typical: "Hourly batch", winner: "voxmaster" },
  { feature: "Test call provisioning", voxmaster: "< 48 hours", typical: "3–7 business days", winner: "voxmaster" },
  { feature: "Transit diversity per PoP", voxmaster: "3+ carriers", typical: "1–2 carriers", winner: "voxmaster" },
];

export const businessTypes = [
  {
    icon: "ri-headphone-line",
    title: "Call centers & BPO",
    desc: "High-volume inbound and outbound voice with carrier-grade ASR, real-time route failover, and per-destination quality dashboards built for SLA-bound operations.",
    color: "primary",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "E-commerce & retail",
    desc: "Transactional SMS, voice OTP, and click-to-call support that keep order confirmations, delivery updates, and customer service flowing across every channel.",
    color: "accent",
  },
  {
    icon: "ri-router-line",
    title: "Retail Carriers",
    desc: "Get A-Z coverage for voice traffic at competitive rates, prevent voice fraud, eliminate grey routes and secure revenues.",
    color: "secondary",
  },
  {
    icon: "ri-smartphone-line",
    title: "OTT Services",
    desc: "Reliable voice termination and origination for OTT calling and messaging apps — global coverage, high ASR, and low-latency routing that keep your users connected everywhere.",
    color: "primary",
  },
];